import { render, staticRenderFns } from "./SysCta.vue?vue&type=template&id=00f4fd22"
import script from "./SysCta.vue?vue&type=script&lang=js"
export * from "./SysCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports